import { call, put, takeEvery } from "redux-saga/effects";

// new Password Redux States
import {
  ADD_EMAIL_INTEGRATION,
  GET_EMAIL_INTEGRATION,
  GET_EMAIL_TEST,
} from "./actionTypes";

import {
  addEmailIntegrationFailed,
  addEmailIntegrationSuccess,
  getEmailIntegrationFailed,
  getEmailIntegrationSuccess,
  getEmailTestFailed,
  getEmailTestSuccess,
} from "./actions";
//Include Both Helper File with needed methods

import { getCall, postCall } from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";

function* addEmailIntegrationHandler(data) {
  try {
    let realData = data.payload;
    let apiUrl = constClass.REST_API_EMAIL_INTEGRATION;
    const response = yield call(postCall, apiUrl, realData);
    yield put(
      addEmailIntegrationSuccess(
        "Email Integration has been updated successfully.",
      ),
    );
  } catch (error) {
    yield put(addEmailIntegrationFailed(error));
  }
}

function* getEmailIntegrationHandler(data) {
  try {
    let apiUrl = constClass.REST_API_EMAIL_INTEGRATION;
    const response = yield call(getCall, apiUrl);
    yield put(getEmailIntegrationSuccess(response));
  } catch (error) {
    yield put(getEmailIntegrationFailed(error));
  }
}

// ✅ UPDATE getEmailTestHandler:
function* getEmailTestHandler(data) {
  try {
    const recipientEmail = data.payload; // email passed from action
    let apiUrl =
      constClass.REST_API_EMAIL_INTEGRATION +
      "/test?recipientEmail=" +
      encodeURIComponent(recipientEmail);
    const response = yield call(getCall, apiUrl);
    yield put(
      getEmailTestSuccess("Test email sent successfully to " + recipientEmail),
    );
  } catch (error) {
    const errorMessage =
      typeof error === "string"
        ? error
        : error?.response?.data?.message ||
          error?.message ||
          "Something went wrong";
    yield put(getEmailTestFailed(errorMessage));
  }
}

function* emailIntegrationSaga() {
  yield takeEvery(ADD_EMAIL_INTEGRATION, addEmailIntegrationHandler);
  yield takeEvery(GET_EMAIL_INTEGRATION, getEmailIntegrationHandler);
  yield takeEvery(GET_EMAIL_TEST, getEmailTestHandler);
}

export default emailIntegrationSaga;
